import * as React from "react";
import {useEffect} from "react";
import {FlyoutSuperUserNavigationMenu} from "@/components/admin/FlyoutSuperUserNavigationMenu";

export const Analytics = (props) => {
	const {selectedMenuOption, setSelectedMenuOption} = props;

	useEffect(() => {
		console.log("(Analytics.jsx) Analytics Component Mounted!");

		return () => {
			console.log("(Analytics.jsx) Analytics Component Unmounted!");
		};
	}, []);

	return (
		<div
			className="flex flex-col items-start justify-between h-full space-y-2
                portrait:p-[0.75rem] portrait:jk:p-[1.25rem]
                landscape:px-[1rem] landscape:py-[0.75rem]
                landscape:jk:px-[1rem] landscape:jk:py-[0.75rem]"
		>
			{/* Header */}
			<div className={"flex flex-col items-start justify-between w-full gap-1"}>
				<div className={"flex items-center gap-2"}>
					{/* Navigation Button for Mobile */}
					<FlyoutSuperUserNavigationMenu
						selectedMenuOption={selectedMenuOption}
						setSelectedMenuOption={setSelectedMenuOption}
					/>

					{/* Heading */}
					<h1
						className="font-custom-bold leading-tight
                        portrait:text-[1.5rem] portrait:md:text-[1.375rem]
                        portrait:jk:text-[1.5rem] portrait:lg:text-[2rem
                        landscape:text-[0.65rem] landscape:md:text-[0.875rem]
                        landscape:jk:text-[1rem] landscape:lg:text-[1.5rem]"
					>
						Analytics
					</h1>
				</div>
			</div>

			{/* Body */}
			<div className={`w-full flex-1 flex items-center justify-center gap-2 overflow-hidden`}>
				<p className="text-gray-600 font-custom-semi-bold-italic">
					No analytics available at the moment.
				</p>
			</div>
		</div>
	);
}
